import {Directive, EventEmitter, HostListener, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DeleteConfirmationComponent} from '../components/delete-confirmation/delete-confirmation.component';

@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: '[deleteConfirmation]'
})
export class DeleteConfirmationDirective {

  @Output() deleteConfirmation: EventEmitter<any> = new EventEmitter<any>();

  constructor(public dialog: MatDialog) {
  }

  @HostListener('click') onClick(): void {
    const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteConfirmation.emit();
      }
    });
  }
}
